import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "subTitle", "state", "icon", "children", "additionalContent", "actions"];
import React from 'react';
import { cnBem } from '@carnica/utils';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { Text } from "../../Text";
import { StatusViewIndicator } from "../StatusViewIndicator";
import styles from "../styles.pcss";
import { StatusViewActions } from "../StatusViewActions";
import { statusViewPropState } from "../types";
var cnStatusView = cnBem('status-view', styles);
export var StatusViewContent = function StatusViewContent(props) {
  var title = props.title,
    subTitle = props.subTitle,
    _props$state = props.state,
    state = _props$state === void 0 ? statusViewPropState[0] : _props$state,
    icon = props.icon,
    children = props.children,
    additionalContent = props.additionalContent,
    actions = props.actions,
    getters = _objectWithoutProperties(props, _excluded);
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StatusViewIndicator, {
    className: cnStatusView('indicator'),
    icon: icon,
    state: state,
    "data-t-id": "StatusView-StatusViewContent"
  }), /*#__PURE__*/React.createElement("div", {
    className: cnStatusView('title')
  }, title && /*#__PURE__*/React.createElement(Text, {
    align: "center",
    color: "primary",
    variant: "headline-small"
  }, title), subTitle && /*#__PURE__*/React.createElement(Text, {
    align: "center",
    color: "secondary",
    variant: isMobile ? 'body-small' : 'body-medium'
  }, subTitle)), /*#__PURE__*/React.createElement(StatusViewActions, _extends({
    actions: actions,
    className: cnStatusView('actions')
  }, getters)), children && /*#__PURE__*/React.createElement("div", {
    className: cnStatusView('container')
  }, children), additionalContent && /*#__PURE__*/React.createElement("div", {
    className: cnStatusView('content')
  }, additionalContent));
};